/// <reference path='../_all.ts' />

module blog {

  
  export class blogService implements IBlogService {
    static $inject = ['$http'];

    constructor(
      private $http: ng.IHttpService
    ) { }

    public loadTopicRange(StartingIndex: number, 
      NrOfItems: number, 
      FilterString2: string, 
      Tags: editor.ContentTag[], 
      onlyFeatured : boolean,
      checkDate? : boolean,
      hl?: ILanguageInfo,): ng.IHttpPromise<editor.Content[]> {

      return this.$http<editor.Content[]>({
        method: "POST"
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Blog/GetTopicsRange"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          StartingIndex: StartingIndex,
          NrOfEntries: NrOfItems,
          FilterString2: FilterString2,
          onlyFeatured: onlyFeatured,
          checkDate: checkDate,
        }
        , data: Tags
      }).then((response) => {
        return response;
      });

    }

    public loadByProduct(rpv: IRouteParameter[]): ng.IHttpPromise<editor.Content[]> {

      return this.$http<editor.Content[]>({
        method: "POST"
        , url: "/api/" + (pglob.RouteData.CurrentLanguage).hl + "/Blog/ByProduct"
        , headers: { 'Content-Type': 'application/json' }
        , data : rpv 
      }).then((response) => {
        response.data.forEach((c) => {
          if (c.ContentMeta.CreatedAt) c.ContentMeta.CreatedAt = new Date(<any>c.ContentMeta.CreatedAt); //we recieve that as string, have to convert it.
          if (c.ContentMeta.PublishedAt) c.ContentMeta.PublishedAt = new Date(<any>c.ContentMeta.PublishedAt); //we recieve that as string, have to convert it.
          if (c.ContentMeta.ModifiedAt) c.ContentMeta.ModifiedAt = new Date(<any>c.ContentMeta.ModifiedAt); //we recieve that as string, have to convert it.
        });
        return response;
      })

    }

  }

}